import { AXIOS } from "@/AXIOS/http-common";

const state = {
  usersList: [],
  managerList: [],
  usersByManager: [],
  OrganizationForManagerList: [],
  usersFilter: { action: "getAllUsers", data: { page: 0, size: 20 } },
  usersChangedAt: 0,
};

const urlPrefix = "/admin/user";

const actions = {
  async reloadUsers(context, pageOptions) {
    const { action, data } = context.state.usersFilter;
    return await context.dispatch(action, { ...data, ...pageOptions });
  },

  async reloadUsersAfterDelete(context) {
    await context.dispatch("reloadUsers");
    const { action, data } = context.state.usersFilter;
    if (context.state.usersList.content.length > 0) {
      return;
    }
    if (data.page > 0) {
      // Удалили последнего пользователя на странице — переходим на предыдущую
      return await context.dispatch("reloadUsers", { page: data.page - 1 });
    }
    if (action === "searchUserByUsername") {
      // Под фильтр по логину больше никто не подходит — снимаем его
      if (data.organizationId) {
        return await context.dispatch("searchUserByOrganizationId", {
          id: data.organizationId,
          page: 0,
          size: data.size,
        });
      }
      return await context.dispatch("getAllUsers", { page: 0, size: data.size });
    }
  },

  async getAllUsers(context, data) {
    context.commit("setUsersFilter", { action: "getAllUsers", data });
    return await AXIOS.get(
      urlPrefix + "/list?page=" + data.page + "&size=" + data.size
    ).then((response) => {
      console.log(response.data);
      response.data.content.forEach(element => {
        let name = element.fullName;
        if (name.length > 2) {
          element.fullName = name[0] + "*".repeat(name.length - 2) + name[name.length - 1];
        } else if (name.length === 2) {
          element.fullName = name[0] + "*";
        }
      });
      context.commit("setUsersList", response.data);
    });
  },

  async searchUserByOrganizationId(context, data) {
    context.commit("setUsersFilter", {
      action: "searchUserByOrganizationId",
      data,
    });
    return await AXIOS.get(
      urlPrefix +
        "/find/" +
        "?organizationId=" +
        data.id +
        "&page=" +
        data.page +
        "&size=" +
        data.size
    ).then((response) => {
      console.log(response.data);
      context.commit("setUsersList", response.data);
    });
  },

  async searchUserByUsername(context, data) {
    context.commit("setUsersFilter", { action: "searchUserByUsername", data });
    return await AXIOS.get(urlPrefix + "/findByUsername", {
      params: {
        username: data.username,
        organizationId: data.organizationId,
        page: data.page,
        size: data.size,
      },
    }).then((response) => {
      context.commit("setUsersList", response.data);
    });
  },

  async getUsernameSuggestions(context, data) {
    return await AXIOS.get(urlPrefix + "/findByUsername", {
      params: {
        username: data.username,
        organizationId: data.organizationId,
        page: 0,
        size: data.size || 50,
      },
    }).then((response) => response.data.content);
  },

  async searchUsersForManager(context, data) {
    console.log(data);
    return await AXIOS.get(
      urlPrefix +
        "/findForManagerSelector?organizationId=" +
        data.organizationId +
        "&roleId=" +
        data.roleId
    ).then((response) => {
      console.log(response.data);
      context.commit("setManagerList", response.data);
    });
  },

  async searchOrganizationForManager(context, data) {
    console.log(data);
    return await AXIOS.get(
      "/user/organization/hierarchy?organizationId=" + data.organizationId
    ).then((response) => {
      console.log(response.data);
      context.commit("setOrganizationForManagerList", response.data);
    });
  },

  async getUsersByManager(context, data) {
    console.log(data);
    return await AXIOS.get(urlPrefix + "/get/users/by/manager").then(
      (response) => {
        console.log(response.data);
        context.commit("setUsersByManager", response.data);
      }
    );
  },

  async addUser(context, data) {
    const response = await AXIOS.post(urlPrefix + "/create", data);
    context.commit("setUsersChanged");
    return response;
  },

  async editUser(context, data) {
    const response = await AXIOS.post(urlPrefix + "/edit", data);
    context.commit("setUsersChanged");
    return response;
  },

  async deleteUserById(context, userId) {
    const response = await AXIOS.get(urlPrefix + "/delete?userId=" + userId);
    context.commit("setUsersChanged");
    return response;
  },
};

const mutations = {
  setUsersList(state, data) {
    state.usersList = data;
  },

  setUsersFilter(state, filter) {
    state.usersFilter = filter;
  },

  setUsersChanged(state) {
    state.usersChangedAt = Date.now();
  },

  setOrganizationForManagerList(state, data) {
    state.OrganizationForManagerList = data;
  },

  setManagerList(state, data) {
    state.managerList = data;
  },

  setUsersByManager(state, data) {
    state.usersByManager = data;
  },
};

const getters = {
  GETORGANIZTIONFORMANAGERLIST: (state) => state.OrganizationForManagerList,
  GETUSERSLIST: (state) => state.usersList,
  GETUSERSFILTER: (state) => state.usersFilter,
  GETUSERSCHANGEDAT: (state) => state.usersChangedAt,
  GETMANAGERLIST: (state) => state.managerList,
  GETUSERSBYMANAGER: (state) => state.usersByManager,
};

export default {
  state,
  actions,
  mutations,
  getters,
};
